import { Expose } from "class-transformer";
import { IsNumber, IsString, IsOptional } from "class-validator";

export class MailContent {
  @IsNumber()
  @Expose()
  mailContentKeyEnum!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  mailConfigurationId!: number | null;
  @IsString()
  @Expose()
  mailContents!: string;
  @IsOptional()
  @IsString()
  @Expose()
  contractorId!: string | null;

  constructor() {
    this.mailContentKeyEnum = 0;
    this.mailConfigurationId = 0;
    this.mailContents = "";
    this.contractorId = null;
  }
}
